import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { Observable } from 'rxjs';
import { ROUTES_ARCHIVOS } from '../constants/constant.model';
import { HttpClient } from '@angular/common/http';
import { StorageService } from './storage.service';

@Injectable({
    providedIn: 'root'
})


export class ProveedorService {
    public sessionInfo = JSON.parse(StorageService.getSession());
    public ciaId = this.sessionInfo.id_cia;
    constructor(private apiService: ApiService, private http: HttpClient) { }

    buscarProveedor(codpro: string, razonc: string,
        dident: string, limit: number, offset: number, soloactivos: boolean): Observable<any> {
        this.apiService.setUrlPathApi(ROUTES_ARCHIVOS.proveedor_buscar_url);
        return this.apiService.execGetQueryJson(`buscar?codpro=${encodeURIComponent(codpro)}&razonc=${encodeURIComponent(razonc)}&dident=${dident}&soloactivos=${soloactivos}&limit=${limit}&offset=${offset}`);
    }




    insertProveedor(proveedor: any) {
        this.apiService.setUrlPathApi("proveedor/");
        return this.apiService.executePostJson(proveedor).pipe();
    }

    obtenerProveedor(codpro: string, soloActivos: Boolean): Observable<any> {
        this.apiService.setUrlPathApi("proveedor/");
        return this.apiService.execGetQueryJson(`${codpro}` + ((soloActivos != null) ? ("?soloActivos=" + soloActivos) : ""))
    }
    obtenerProveedorV2(codpro: string, razonc: string, soloActivos: Boolean): Observable<any> {
        this.apiService.setUrlPathApi("proveedor/v2/buscar");
        return this.apiService.execGetQueryJson(`?codpro=${encodeURI(codpro)}&razonc=${encodeURI(razonc)}&soloActivos=${soloActivos}`)
    }
    actualizarProveedor(proveedor: any) {
        this.apiService.setUrlPathApi("proveedor/");
        return this.apiService.executePutJson(proveedor).pipe();
    }

    eliminarProveedor(codpro: any): Observable<any> {
        this.apiService.setUrlPathApi(`proveedor/`);
        return this.apiService.executeDeleteJson(`${codpro}`);
    }
    obtener_sunat_codigo(): Observable<any> {
        this.apiService.setUrlPathApi(ROUTES_ARCHIVOS.proveedor_buscar_url);
        return this.apiService.execGetQueryJson(``)
    }
    //!!FALTA!!!! no FUNCIONA PARA PROVEEDOR
    //servicios de eliminar
    eliminarClase(codpro: any, clase: any): Observable<any> {
        this.apiService.setUrlPathApi(`proveedor/`);
        return this.apiService.executeDeleteJson(`${codpro}/clases/${clase}`);
    }
    eliminar_contacto_prov(codpro: any, codcont: any): Observable<any> {
        this.apiService.setUrlPathApi(`proveedor/`);
        return this.apiService.executeDeleteJson(`${codpro}/contactos/${codcont}`);
    }
    eliminar_contacto(codpro: any, codcont: any): Observable<any> {
        this.apiService.setUrlPathApi(`cliente/`);
        return this.apiService.executeDeleteJson(`${codpro}/contactos/${codcont}`);
    }
    eliminar_especificacion(codpro: any, codesp: any): Observable<any> {
        this.apiService.setUrlPathApi(`cliente/`);
        return this.apiService.executeDeleteJson(`${codpro}/especificaciones/${codesp}`);
    }
    eliminar_direcciones_envio(codpro: any, codenv: any): Observable<any> {
        this.apiService.setUrlPathApi(`cliente/`);
        return this.apiService.executeDeleteJson(`${codpro}/direcciones-envio/${codenv}`);
    }
    eliminar_direcciones_envio_prov(codpro: any, codenv: any): Observable<any> {
        this.apiService.setUrlPathApi(`proveedor/`);
        return this.apiService.executeDeleteJson(`${codpro}/direcciones-envio/${codenv}`);
    }
    eliminar_bancos(codpro: any, codefi: any, tipcta: any, moneda: any): Observable<any> {
        this.apiService.setUrlPathApi(`cliente/`);
        return this.apiService.executeDeleteJson(`${codpro}/bancos/${codefi}/tipo-cuenta/${tipcta}/moneda/${moneda}`);
    }
    eliminar_bancos_prov(codpro: any, codefi: any, tipcta: any, moneda: any): Observable<any> {
        this.apiService.setUrlPathApi(`cliente/`);
        return this.apiService.executeDeleteJson(`${codpro}/bancos/${codefi}/tipo-cuenta/${tipcta}/moneda/${moneda}`);
    }
    insertContactoInterlocutor(codcli: any, condcot: any): Observable<any> {
        this.apiService.setUrlPathApi(ROUTES_ARCHIVOS.proveedor_buscar_url + `${codcli}/contactos/${condcot}`);
        return this.apiService.executePostJson(null);
    }
    actualizar_bancos_prov(codcli: any, proveedorBanco: any) {
        this.apiService.setUrlPathApi(`cliente/${codcli}/bancos`);
        return this.apiService.executePutJson(proveedorBanco).pipe();
    }
    actualizar_bancos(codcli: any, proveedorBanco: any) {
        this.apiService.setUrlPathApi(`cliente/${codcli}/bancos`);
        return this.apiService.executePutJson(proveedorBanco).pipe();
    }
    obtener_lista_clases(): Observable<any> {
        this.apiService.setUrlPathApi("cliente/clases");
        return this.apiService.execGetJson();
    }

    obtener_lista_clases_proveedor(): Observable<any> {
        this.apiService.setUrlPathApi("proveedor/clases");
        return this.apiService.execGetJson();
    }

    obtener_lista_clases_codigos(clase: any): Observable<any> {
        this.apiService.setUrlPathApi(`cliente/clases/${clase}/codigos`);
        return this.apiService.execGetJson();
    }
    obtener_lista_clases_codigos_proveedores(clase: any): Observable<any> {
        this.apiService.setUrlPathApi(`proveedor/clases/${clase}/codigos`);
        return this.apiService.execGetJson();
    }
    insertar_bancos(codcli: any, proveedorBanco: any): Observable<any> {
        this.apiService.setUrlPathApi(`cliente/${codcli}/bancos`);
        return this.apiService.executePostJson(proveedorBanco).pipe();
    }
    insertar_bancos_prov(codcli: any, proveedorBanco: any): Observable<any> {
        this.apiService.setUrlPathApi(`cliente/${codcli}/bancos`);
        return this.apiService.executePostJson(proveedorBanco).pipe();
    }
    obtener_clases_cliente(tipcli: any) {
        this.apiService.setUrlPathApi(`clases-genericas/interlocutor-comercial/${tipcli}/clases`);
        return this.apiService.execGetJson();
    }
    obtener_clases_cliente_codigo(tipcli: any, clase: any) {
        this.apiService.setUrlPathApi(`clases-genericas/interlocutor-comercial/${tipcli}/clases/${clase}/codigos`);
        return this.apiService.execGetJson();
    }
    /****** Documento Adjuntos***************** */
    insertarAdjuntoProveedor(data: any): Observable<any> {
        this.apiService.setUrlPathAdjuntos(`archivos/${this.ciaId}/interlocutor-adjunto`);
        return this.apiService.executePostJson(data).pipe();
    }

    actualizarAdjuntoProveedor(data: any): Observable<any> {
        this.apiService.setUrlPathAdjuntos(`archivos/${this.ciaId}/interlocutor-adjunto`);
        return this.apiService.executePutJson(data).pipe();
    }

    deleteAdjuntoProveedor(codcli: any, tipcli: any, id: any): Observable<any> {
        this.apiService.setUrlPathAdjuntos(`archivos/${this.ciaId}/interlocutor-adjunto`);
        return this.apiService.executeDeleteJson(`/${id}?tipcli=${tipcli}&codcli=${codcli}`)
    }

    obtenerAdjuntoProveedor(codcli: any, tipcli: any): Observable<any> {
        this.apiService.setUrlPathAdjuntos(`archivos/${this.ciaId}/interlocutor-adjunto/buscar`);
        return this.apiService.execGetQueryJson(`?tipcli=${tipcli}&codcli=${codcli}`)
    }

    descargarAdjuntoProveedor(codcli: any, tipcli: any, id: any): Observable<any> {
        this.apiService.setUrlPathAdjuntos(`archivos/${this.ciaId}/interlocutor-adjunto/descargar/` + id);
        return this.apiService.execGetQueryJsonPDF(`?tipcli=${tipcli}&codcli=${codcli}`).pipe()
    }
} 